// Our story: from "who watches the agents?" to a platform, and now a community.
import { Link } from "react-router";

import { useTitle } from "../ui/hooks";
import { RedPen } from "../ui/RedPen";

const CHAPTERS = [
  {
    kicker: "It started with a question",
    title: "Who checks the agents?",
    body: "OpenCloudSecurity began as an idea for a tool to oversee AI agents: to make sure the companies building them, and the agents themselves, were vetted, and that the work agents did was supervised and could not quietly breach anyone's privacy. Our first slogan said it plainly: you can't trust AI companies to mark their own homework.",
  },
  {
    kicker: "Then we built it",
    title: "A platform that runs agents for real.",
    body: "The concept became software. Today OCS runs real engineering work every day: agents in isolated environments, a broker that keeps every key away from them, approvals answered from a phone, conversations encrypted to their owners, workflows that guard every token. We learned what supervision actually takes by doing it.",
  },
  {
    kicker: "Now it's bigger than us",
    title: "A community that sets the bar.",
    body: "No single company, ours included, should decide how AI behaves. So we are opening up: teaching people to secure their access, giving the tools away, publishing workflows in an open format, and gathering organisations and individuals behind a Charter that AI companies can be held to.",
  },
];

export function About() {
  useTitle("Our story");
  return (
    <>
      <section className="grain border-b border-line">
        <div className="wrap py-16 sm:py-24">
          <p className="kicker">§ Our story</p>
          <h1 className="display mt-4 max-w-5xl text-[3rem] sm:text-[4.6rem] lg:text-[5.4rem]">
            From a concept to a <RedPen kind="circle">movement.</RedPen>
          </h1>
        </div>
      </section>
      <section className="wrap py-10">
        {CHAPTERS.map((c, i) => (
          <div key={c.title} className="grid gap-4 border-b border-line py-12 last:border-0 md:grid-cols-[7rem_1fr_1.4fr] md:gap-10">
            <span className="font-display text-6xl font-extrabold leading-none text-signal">{i + 1}</span>
            <div>
              <p className="kicker">{c.kicker}</p>
              <h2 className="mt-2 font-display text-3xl font-bold leading-tight tracking-[-0.025em]">{c.title}</h2>
            </div>
            <p className="font-serif text-[1.25rem] leading-relaxed text-ink2">{c.body}</p>
          </div>
        ))}
      </section>
      <section className="wrap">
        <div className="flex flex-col gap-6 rounded-3xl bg-ink p-8 text-paper sm:flex-row sm:items-center sm:justify-between sm:p-12">
          <p className="display max-w-2xl text-4xl sm:text-5xl">The next chapter has your name in it.</p>
          <Link to="/charter#sign" className="btn-signal shrink-0">
            Sign the Charter
          </Link>
        </div>
      </section>
    </>
  );
}
